import {Link} from '@/components-v2'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useMemo} from 'react'
import {useNavigate} from 'react-router-dom'
import {splitUtcToLocalDate} from '@/helpers/dateUtils'

// Guards against path traversal / injection when building detail routes.
const toSafeRouteParam = value => {
  const raw = String(value ?? '').trim()

  if (!raw || raw.includes('..') || !/^[A-Za-z0-9._-]+$/.test(raw)) {
    return ''
  }

  return encodeURIComponent(raw)
}

const InventoryLinkCell = ({text, onClick}) =>
  onClick ? <Link useAnchor={false} label={text ?? '-'} onClick={onClick} /> : (text ?? '-')

export const useInventoryListColumnsV2 = colConfig => {
  const navigate = useNavigate()

  return useMemo(() => {
    if (!colConfig?.length) return []

    const goToProductReview = productId => {
      const safeProductId = toSafeRouteParam(productId)
      return safeProductId ? () => navigate(ROUTES.PRODUCT_REVIEW.replace(':id', safeProductId)) : undefined
    }

    const cellDataByColumn = {
      productId: ctx => (
        <InventoryLinkCell text={ctx.row.original?.productId} onClick={goToProductReview(ctx.row.original?.productId)} />
      ),
      lastUpdated: ctx => {
        const lastUpdated = ctx.row.original?.lastUpdated

        return lastUpdated ? splitUtcToLocalDate(lastUpdated, undefined, 'dd-MM-yyyy') : '-'
      },
    }

    const defaultCellData = columnKey => ctx => ctx.row.original?.[columnKey] ?? '-'

    return colConfig.map(col => {
      const columnKey = col.columnKey || col.name_of_db_column
      const header = col.header || col.label_of_column || col.columnFilterPlaceholder || columnKey

      return {
        id: columnKey,
        columnKey,
        header,
        columnFilterPlaceholder: col.columnFilterPlaceholder || header,
        filterVariant: col.filterVariant || 'text',
        minSize: col.minSize,
        maxSize: col.maxSize,
        initialSize: col.initialSize,
        cellData: cellDataByColumn[columnKey] ?? defaultCellData(columnKey),
      }
    })
  }, [colConfig, navigate])
}
